import axios from 'axios';
import config from '../../../config';
import Cookies from 'js-cookie';

const baseUrl = config.baseUrl; // URL base de tu API
const planesCompraEndpoint = '/api/financiero/planesdecompra'; // Endpoint para consultar los planes de compra

// Crear una instancia de Axios con la configuración base
const api = axios.create({
    baseURL: baseUrl,
});

// Interceptor de solicitud para añadir el token de autorización
api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * Función para listar todos los planes de compra
 * @returns {Promise<Object>} Respuesta con status y datos o mensaje de error
 */
export const getPlanesCompra = async () => {
    try {
        const response = await api.get(planesCompraEndpoint);
        return response.data; // Devuelve los datos del servicio
    } catch (error) {
        console.error('Error al obtener los planes de compra:', error.message || error);
        return {
            status: error.response ? error.response.status : 500,
            message: error.message || 'Error al obtener los planes de compra',
        };
    }
};
